// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".multiple-choice-one-answer[data-v-2af4995a]{display:flex;flex-direction:row;align-items:flex-start}.element[data-v-2af4995a]{padding:0 4px}", ""]);
// Exports
module.exports = exports;
